import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "h-fit max-h-full w-full max-w-[1200px] flex gap-3 bg-main-10 rounded-3xl animate-popup shadow-material"
};
const _hoisted_2 = {
  class: "w-full flex bg-main-5 rounded-3xl shrink-[0.75] shadow-weak_material overflow-hidden"
};
const _hoisted_3 = {
  class: "relative w-full flex flex-col gap-6"
};
const _hoisted_4 = {
  class: "w-full flex items-center gap-2 justify-between p-6 pb-0"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = {
  key: 0,
  class: "absolute h-9 w-9 loading-spinner-outlined_secondary"
};
const _hoisted_7 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 flex items-center justify-center gap-3 text-main-50 font-light"
};
const _hoisted_8 = {
  class: "min-h-[250px] w-full flex flex-col gap-10 overflow-y-auto scroll-main p-6 pt-0"
};
const _hoisted_9 = {
  class: "flex items-center gap-3 text-sm text-main-60"
};
const _hoisted_10 = {
  class: "whitespace-nowrap font-light"
};
const _hoisted_11 = {
  class: "w-full flex flex-col gap-3"
};
const _hoisted_12 = {
  key: 0,
  class: "icon-check-rounded text-main-100 text-3xl"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  class: "flex flex-col gap-4 p-4"
};
const _hoisted_15 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_16 = {
  class: "flex items-center gap-4"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "text-main-50"
};
const _hoisted_19 = ["title"];
const _hoisted_20 = {
  key: 0,
  class: "contents"
};
const _hoisted_21 = {
  class: "flex items-center gap-2 p-4"
};
const _hoisted_22 = {
  key: 1,
  class: "contents"
};
const _hoisted_23 = {
  key: 1,
  class: "h-1 w-1 shrink-0 bg-current rounded-full"
};
const _hoisted_24 = {
  key: 0,
  class: "w-full flex rounded-3xl overflow-hidden"
};
const _hoisted_25 = {
  class: "w-full flex flex-col gap-6"
};
const _hoisted_26 = {
  class: "w-full flex flex-col gap-3 overflow-y-auto scroll-main p-6 pt-0"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "flex items-center gap-4"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "text-main-50"
};
const _hoisted_31 = {
  class: "flex items-center gap-3 ml-auto"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = {
  key: 0,
  class: "icon-lock-close text-lg text-main-50"
};
const _hoisted_34 = {
  key: 0,
  class: "flex items-center gap-3 text-cta-100 ml-auto animate-buzz"
};
const _hoisted_35 = {
  key: 0,
  class: "contents"
};
const _hoisted_36 = {
  class: "flex flex-col p-4 gap-4"
};
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col gap-1"
};
const _hoisted_38 = {
  class: "flex items-center gap-3"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  class: "h-5 w-5 flex items-center justify-center"
};
const _hoisted_41 = {
  class: "text-xs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                        
                                                      
                                                                                  
  const _component_Toggle = _resolveComponent("Toggle");
  const _component_Button = _resolveComponent("Button");
  const _component_UserResourcesManager = _resolveComponent("UserResourcesManager");
  const _component_Modal = _resolveComponent("Modal");
                                                          
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.open ? (_openBlock(), _createBlock(_component_Modal, {
    key: 0,
    slotsConfig: _ctx.modalSlots
  }, {
    modal: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("p", {
      class: "text-lg font-medium"
    }, "Robots programados", -1)), !$options.ReadonlyMode ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "flex items-center justify-center",
      title: _ctx.executionInProgress ? 'Los procesos se lanzarán automáticamente' : 'No hay nada que lanzar'
    }, [_ctx.executionInProgress ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("i", {
      class: _normalizeClass(["icon-play-rounded text-second-100 text-4xl", {
        'text-main-50!': !_ctx.executionInProgress
      }])
    }, null, 2)], 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_v_card, {
      key: 1,
      loading: "",
      class: "bg-transparent shadow-none pt-2 px-1 text-2xs"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("p", null, "Esperando automatizaciones", -1)])),
      _: 1
    }))]), !$options.SomeTask ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[4] || (_cache[4] = [_createElementVNode("i", {
      class: "icon-less-rounded text-2xl"
    }, null, -1), _createTextVNode(" No tienes ningún proceso automatizado ")]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.TasksByExecutionDateGroup, (group, key) => {
      return _openBlock(), _createElementBlock("div", {
        key: group,
        class: "w-full flex flex-col gap-6"
      }, [_createElementVNode("div", _hoisted_9, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "h-px w-full bg-main-100/15"
      }, null, -1)), _createElementVNode("p", _hoisted_10, _toDisplayString($options.GetTasksGroupName(key)), 1), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "h-px w-full bg-main-100/15"
      }, null, -1))]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, task => {
        return _openBlock(), _createElementBlock("div", {
          key: task,
          class: _normalizeClass(["w-full flex gap-3 items-center text-xs animate-popup", {
            'opacity-60!': !$options.ReadonlyMode && !task.app.active
          }])
        }, [_createElementVNode("div", {
          class: _normalizeClass(["bg-second-100 rounded-2xl py-1 px-3 text-main-5 shadow-weak_material", [{
            'bg-transparent! shadow-none!': task.done
          }, {
            'bg-main-50!': !task.app.active
          }]])
        }, [task.done ? (_openBlock(), _createElementBlock("i", _hoisted_12)) : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$formatDate({
          date: task.scheduledDate,
          format: 'hh:mm'
        })), 1))], 2), _createVNode(_component_v_card, {
          class: "group h-fit w-full flex flex-col rounded-lg bg-second-5 border border-second-10 shadow-weak_material",
          loading: task.executionInProgress
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [task.app?.icon ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass([task.app.icon, "text-2xl"])
          }, null, 2)) : _createCommentVNode("", true), task.app?.image ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: task.app.image,
            alt: "",
            class: "h-6 w-6"
          }, null, 8, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(task.title ?? task.app?.title), 1), _createElementVNode("p", _hoisted_18, _toDisplayString(task.description), 1)])]), task.canBeRemoved && !task.executionInProgress ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
            key: 0,
            class: "opacity-0 group-hover:opacity-100",
            icon: "icon-trash",
            variant: "plain",
            loading: task.removing,
            disabled: task.executionInProgress,
            ref_for: true
          }, _ctx.$vuetifyBinding({
            size: 'sm'
          }), {
            onClick: $event => $options.DeleteFlowSchedule(task)
          }), null, 16, ["loading", "disabled", "onClick"])) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.info, info => {
            return _openBlock(), _createElementBlock("div", {
              key: info,
              class: "flex items-center justify-between flex-wrap"
            }, [_createElementVNode("div", {
              class: "w-fit flex items-center gap-2 py-1 px-2 rounded bg-second-100/5 border border-second-100/5 text-xs",
              title: info.tooltip
            }, [_createElementVNode("i", {
              class: _normalizeClass(["text-sm", info.icon])
            }, null, 2), _createTextVNode(" " + _toDisplayString(info.text), 1)], 8, _hoisted_19)]);
          }), 128))]), task.repeat && task.every ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[8] || (_cache[8] = _createElementVNode("div", {
            class: "relative h-px w-full bg-second-10"
          }, null, -1)), _createElementVNode("div", _hoisted_21, [_cache[7] || (_cache[7] = _createElementVNode("i", {
            class: "icon-calendar text-lg"
          }, null, -1)), _createTextVNode(" Se lanza cada " + _toDisplayString(task.every) + " " + _toDisplayString($options.GetScheduleInterval(task.interval, task.every)), 1)])])) : _createCommentVNode("", true), task.items?.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[9] || (_cache[9] = _createElementVNode("div", {
            class: "relative h-px w-full bg-second-10"
          }, null, -1)), _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col gap-1 p-4", {
              'lessthan': task.items?.length < 3
            }])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.items, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item,
              class: "flex items-center gap-2 in-[.lessthan]:bg-transparent! in-[.lessthan]:px-0! odd:bg-second-100/5 even:bg-second-50/5 py-1 px-2 rounded"
            }, [item.leadingIcon ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(item.leadingIcon)
            }, null, 2)) : _createCommentVNode("", true), item.dot ? (_openBlock(), _createElementBlock("div", _hoisted_23)) : _createCommentVNode("", true), _createElementVNode("p", null, _toDisplayString(item.text), 1), item.icon ? (_openBlock(), _createElementBlock("i", {
              key: 2,
              class: _normalizeClass([item.icon, "ml-auto"])
            }, null, 2)) : _createCommentVNode("", true)]);
          }), 128))], 2)])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["loading"])], 2);
      }), 128))])]);
    }), 128))])])]), !$options.ReadonlyMode ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[13] || (_cache[13] = _createElementVNode("p", {
      class: "text-lg font-medium p-6 pb-0"
    }, "Control de aplicaciones", -1)), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, app => {
      return _openBlock(), _createElementBlock("div", {
        key: app,
        class: "h-fit flex flex-col rounded-lg bg-second-5 shadow-weak_material cursor-pointer text-xs"
      }, [_createElementVNode("div", {
        class: "flex flex-col p-4 gap-4",
        onClick: $event => $options.EnableApp(app)
      }, [_createElementVNode("div", _hoisted_28, [app.icon ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass([app.icon, "text-2xl!"])
      }, null, 2)) : _createCommentVNode("", true), app.image ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: app.image,
        alt: "",
        class: "h-6 w-6"
      }, null, 8, _hoisted_29)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(app.title), 1), _createElementVNode("p", _hoisted_30, _toDisplayString(app.description), 1)]), _createElementVNode("div", _hoisted_31, [app.automation && app.enabled && app.timer ? (_openBlock(), _createElementBlock("div", _hoisted_32, [app.timer.isPaused ? (_openBlock(), _createElementBlock("i", _hoisted_33)) : (_openBlock(), _createBlock(_component_v_progress_circular, {
        key: 1,
        "model-value": (_ctx.refreshInterval - app.timer.remaining) / _ctx.refreshInterval * 100,
        size: 16,
        width: 2,
        color: "second-100"
      }, null, 8, ["model-value"]))])) : _createCommentVNode("", true), !app.toggle ? (_openBlock(), _createBlock(_component_Toggle, {
        key: 1,
        modelValue: app.enabled
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])]), app.automation && app.enabled && _ctx.apps.general.enabled && !app.active ? (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[10] || (_cache[10] = [_createElementVNode("i", {
        class: "icon-certificate text-lg"
      }, null, -1), _createElementVNode("p", null, "Añade un certificado para activar esta función", -1)]))) : _createCommentVNode("", true)], 8, _hoisted_27), app.certsConfig ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "relative h-px w-full bg-second-10"
      }, null, -1)), _createElementVNode("div", _hoisted_36, [_createVNode(_component_Button, {
        size: "xs",
        variant: "secondary",
        text: "Añadir certificado",
        icon: "icon-certificate",
        class: "ml-auto",
        onClick: _withModifiers($event => $options.AddCertificate(app), ["stop"])
      }, null, 8, ["onClick"]), app.certificates?.length ? (_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(app.normalizedCertificates, cert => {
        return _openBlock(), _createElementBlock("div", {
          key: cert,
          class: "flex items-center justify-between py-1 p-2 bg-second-10/20 border border-second-10/50 rounded"
        }, [_createElementVNode("div", _hoisted_38, [_cache[11] || (_cache[11] = _createElementVNode("i", {
          class: "icon-certificate text-lg"
        }, null, -1)), _createElementVNode("p", null, _toDisplayString(cert.subject.CN), 1)]), _createElementVNode("i", {
          class: "icon-cross text-xs button-hover",
          onClick: $event => this.DeleteCertificate(app, cert.serialNumber)
        }, null, 8, _hoisted_39)]);
      }), 128))])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
    }), 128))])])])) : _createCommentVNode("", true)])]),
    certificate: _withCtx(() => [_createVNode(_component_UserResourcesManager, _mergeProps({
      searchInputField: false,
      scrollLimit: false,
      type: "certificates",
      shared: false,
      persistentSelection: false,
      selectable: false
    }, _ctx.modalSlots.selectedApp.certsConfig, {
      modelValue: _ctx.modalSlots.selectedCerts,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modalSlots.selectedCerts = $event)
    }), null, 16, ["modelValue"])]),
    _: 1
  }, 8, ["slotsConfig"])) : _createCommentVNode("", true), _createVNode(_component_v_badge, {
    location: "top end",
    color: $options.Tasks.length ? 'cta-75' : 'transparent',
    content: $options.Tasks.length ? $options.Tasks.length : '',
    class: "fixed bottom-3 right-3 flex z-40"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "h-full w-full flex gap-3 items-center justify-center p-3 border-[3px] border-second-50 rounded-3xl shadow-material text-main-5 font-medium bg-second-100 cursor-pointer hover:border-second-10 shrink-0 transition-colors",
      onClick: _cache[1] || (_cache[1] = (...args) => this.ButtonBinding.onclick && this.ButtonBinding.onclick(...args))
    }, [_createElementVNode("div", _hoisted_40, [_createElementVNode("i", {
      class: _normalizeClass(this.ButtonBinding.icon)
    }, null, 2)]), _createElementVNode("p", _hoisted_41, _toDisplayString(this.ButtonBinding.text), 1)])]),
    _: 1
  }, 8, ["color", "content"])], 64);
}

/* Vuetify */
import { VBadge as _component_v_badge } from "vuetify/components/VBadge"
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"
import { VCard as _component_v_card } from "vuetify/components/VCard"
import { VProgressCircular as _component_v_progress_circular } from "vuetify/components/VProgressCircular"

